import { DocumentData, DocumentReference } from 'firebase/firestore';

export interface OperationGroup {
  id: string;
  name: string;
  city?: string;
  description?: string;
  isActive: boolean;
  deliveryResponsibleStoreId?: string | null;
  storeIds: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

export interface OperationGroupFormData {
  code?: string;
  name: string;
  city?: string;
  description?: string;
  isActive: boolean;
}

export const toOperationGroup = (
  doc: DocumentReference<DocumentData> | ({ id: string } & DocumentData)
): OperationGroup => {
  const data = 'data' in doc ? doc.data() : doc;

  return {
    id: doc.id,
    name: data.name || '',
    city: data.city || '',
    description: data.description || '',
    isActive: data.isActive ?? true,
    deliveryResponsibleStoreId: data.deliveryResponsibleStoreId ?? null,
    storeIds: Array.isArray(data.storeIds) ? data.storeIds : [],
    createdAt: data.createdAt?.toDate?.(),
    updatedAt: data.updatedAt?.toDate?.(),
  };
};
